import Chart from "react-apexcharts";

const BAND_CONFIG = [
    { key: "bass_frequency", label: "Bass", range: "20Hz" },
    { key: "low_mid_frequency", label: "Low-Mid", range: "250Hz" },
    { key: "high_mid_frequency", label: "High-Mid", range: "2kHz" },
    { key: "high_frequency", label: "Highs", range: "8kHz" },
];

const STATUS_STYLE = {
    HIGH: { bg: "bg-[#6b3fa0]", text: "text-pink-300", label: "Too High" },
    LOW: { bg: "bg-[#2b4fa3]", text: "text-sky-300", label: "Too Low" },
    OPTIMAL: { bg: "bg-[#1f6f6d]", text: "text-green-300", label: "Optimal" },
    MEDIUM: { bg: "bg-[#1f6f6d]", text: "text-green-300", label: "Optimal" }
};

// Map status to a Y value for the chart line
const STATUS_Y = { HIGH: 85, OPTIMAL: 50, MEDIUM: 50, LOW: 20 };

export default function TonalReportChart({ tonalProfile }) {
    const bands = BAND_CONFIG.map(band => ({
        ...band,
        status: tonalProfile?.[band.key] ?? "OPTIMAL",
    }));

    const chartData = bands.map((band, i) => ({
        x: i,
        y: STATUS_Y[band.status] ?? 50,
    }));

    return (
        <div className="wrapper w-full lg:max-w-[750px] min-w-[60%]">
            <div className="relative w-full h-[130px] bg-[#020b6b] overflow-hidden">

                {/* Dynamic background zones */}
                <div className="absolute inset-0 flex divide-x-2 divide-gray-700">
                    {bands.map(band => (
                        <div
                            key={band.key}
                            className={`w-1/4 opacity-70 ${STATUS_STYLE[band.status]?.bg ?? STATUS_STYLE.OPTIMAL.bg}`}
                        />
                    ))}
                </div>

                {/* Dynamic status labels */}
                <div className="absolute top-2 left-0 right-0 flex text-xs">
                    {bands.map(band => (
                        <div
                            key={band.key}
                            className={`w-1/4 px-3 ${STATUS_STYLE[band.status]?.text ?? STATUS_STYLE.OPTIMAL.text}`}
                        >
                            {STATUS_STYLE[band.status]?.label ?? "Optimal"}
                        </div>
                    ))}
                </div>

                {/* Chart line */}
                <div className="relative z-10 h-full">
                    <Chart
                        type="line"
                        height="100%"
                        series={[{ data: chartData }]}
                        options={{
                            chart: {
                                background: "transparent",
                                toolbar: { show: false },
                                zoom: { enabled: false },
                            },
                            stroke: {
                                curve: "straight",
                                width: 3,
                                colors: ["#e6f7ff"],
                            },
                            grid: { show: false },
                            markers: { size: 0 },
                            dataLabels: { enabled: false },
                            xaxis: {
                                categories: bands.map(band => band.label),
                                labels: { show: false },
                                axisBorder: { show: false },
                                axisTicks: { show: false },
                            },
                            yaxis: { show: false, min: 0, max: 100 },
                            tooltip: {
                                enabled: true,
                                theme: "dark",
                                x: { show: true },
                                custom: ({ dataPointIndex }) => {
                                    const band = bands[dataPointIndex];
                                    const status = STATUS_STYLE[band?.status];
                                    return `
            <div style="padding:8px 12px; background:#1a1a2e; border:1px solid #ffffff33; border-radius:6px; font-size:12px; color:#fff;">
                <strong>${band?.label ?? ''}</strong><br/>
                <span>${status?.label ?? '—'}</span>
            </div>
        `;
                                },
                                // y: {
                                //     formatter: (_, { dataPointIndex }) => {
                                //         const band = bands[dataPointIndex];
                                //         console.log('tooltip data', band?.status, STATUS_STYLE[band?.status]?.label)
                                //         return STATUS_STYLE[band?.status]?.label ?? "Optimal";
                                //     },
                                //     title: {
                                //         formatter: (_, { dataPointIndex }) => {
                                //             return bands[dataPointIndex]?.label ?? "";
                                //         },
                                //     },
                                // },
                                marker: { show: false },
                            }
                        }}
                    />
                </div>
            </div>

            {/* Band labels */}
            <div className="flex text-sm text-blue-200 mt-1">
                {bands.map(band => (
                    <div key={band.key} className="w-1/4 px-1">
                        <div className="text-white/80 font-medium">{band.label}</div>
                        <div className="text-white/40 text-xs">{band.range}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
